module.exports = "pegasus/assets/circle-pinterest.png";